import {FC} from 'react';
import UIStackedInput from '../UICommon/UIStackedInput';
import UIButton from '../UICommon/UIButton';

type RegisterPageFormProps = {
  formValues: any;
  errorMessages: any;
  onChange: Function;
  submit: Function;
}
const RegisterPageForm: FC<RegisterPageFormProps> = ({
  formValues,
  errorMessages,
  onChange,
  submit,
}) => {
  return (
    <form onSubmit={(e) => submit(e)}>
      <UIStackedInput
        onChange={onChange}
        text={formValues.firstName}
        name='firstName'
        labelText='Förnamn'
        placeholder='Fyll i ditt förnamn'
        style='bg-black-matte text-white caret-white'
        textStyle='text-navy-blue font-semibold'
        hideLabelOnMobile={true}
        badInput={errorMessages.firstName}
      />
      <UIStackedInput
        onChange={onChange}
        text={formValues.lastName}
        labelText='Efternamn'
        name='lastName'
        placeholder='Fyll i ditt efternamn'
        style='bg-black-matte text-white caret-white'
        textStyle='text-navy-blue font-semibold'
        hideLabelOnMobile={true}
        badInput={errorMessages.lastName}
      />
      <UIStackedInput
        onChange={onChange}
        text={formValues.email}
        name='email'
        labelText='E-postadress'
        placeholder='Fyll i din e-postadress'
        style='bg-black-matte text-white caret-white'
        textStyle='text-navy-blue font-semibold'
        hideLabelOnMobile={true}
        badInput={errorMessages.email}
      />
      <UIStackedInput
        onChange={onChange}
        text={formValues.password}
        name='password'
        type='password'
        labelText='Lösenord'
        placeholder='Välj lösenord'
        autoComplete='new-password'
        style='bg-black-matte text-white caret-white'
        textStyle='text-navy-blue font-semibold'
        hideLabelOnMobile={true}
        badInput={errorMessages.password}
      />
      <UIStackedInput
        onChange={onChange}
        text={formValues.repeatPassword}
        name='repeatPassword'
        type='password'
        labelText='Bekräfta lösenord'
        placeholder='Bekräfta lösenord'
        style='bg-black-matte text-white caret-white'
        textStyle='text-navy-blue font-semibold'
        hideLabelOnMobile={true}
        badInput={errorMessages.repeatPassword}
      />
      <UIStackedInput
        onChange={onChange}
        text={formValues.studio}
        name='studio'
        labelText='Studio'
        placeholder='Fyll i namnet den studio är på'
        style='bg-black-matte text-white caret-white'
        textStyle='text-navy-blue font-semibold'
        hideLabelOnMobile={true}
        badInput={errorMessages.studio}
      />
      <div className='w-full pt-6 pb-2'>
        <div className='hidden md:block'>
          <UIButton type='full' text='Gå vidare' style="font-semibold 17 font-Manrope"
            buttonType='submit'/>
        </div>
        <div className='md:hidden'>
          <UIButton type='full-white' text='Gå vidare' style="font-semibold 17 font-Manrope"
            buttonType='submit'/>
        </div>
      </div>
    </form>
  );
};

export default RegisterPageForm;
